import axios from "axios";
import { io } from "socket.io-client";
import getEnv from "../configs/env";

export const api = axios.create({
  baseURL: getEnv("VUE_APP_API"),
});
export const socket = io(getEnv("VUE_APP_API"));
